const Tab = ({ currentTab, tab, onClick }) => {
  return (
    <div
      className={`border-b-2 text-center py-2 transition-flex duration-200 ease-in-out flex-1 ${
        currentTab === tab.key
          ? 'border-white font-bold'
          : 'border-black opacity-40'
      }`}
      onClick={onClick}
    >
      {tab.name}
    </div>
  );
};

const Tabs = ({ currentTab, list, handleTab }) => {
  return (
    <div className='flex items-center gap-4 mb-4 text-white'>
      {list.map((item) => (
        <Tab
          key={item.key}
          currentTab={currentTab}
          tab={item}
          onClick={handleTab(item.key)}
        />
      ))}
    </div>
  );
};

export default Tabs;
